export default __webpack_public_path__ + "static/media/product23.e7fc50cb.png";